import { createBrowserHistory } from "history";

//created history object
export default createBrowserHistory();